// extracted by mini-css-extract-plugin
export default {"root":"IconVeriff_root__tHg9c"};